(() => {
  const reset = (button) => {
    window.clearTimeout(Number(button.dataset.checkoutTimer || 0));
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = 'Buy it now';
    delete button.dataset.checkoutTimer;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-oc-raised-buy-now]');
    if (!button || button.disabled) return;

    const productForm = button.closest('product-form');
    const form = productForm?.querySelector('form[data-type="add-to-cart-form"]');
    const submit = productForm?.querySelector('[type="submit"]');
    if (!productForm || !form || !submit) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Preparing secure checkout…';

    const cleanup = () => {
      document.removeEventListener('afterCartChanged', onSuccess);
      document.removeEventListener('afterAddCartError', onError);
    };
    const onSuccess = (cartEvent) => {
      if (cartEvent.detail?.target !== productForm) return;
      cleanup();
      window.location.assign('/checkout');
    };
    const onError = (errorEvent) => {
      if (errorEvent.detail?.target !== productForm) return;
      cleanup();
      reset(button);
    };

    document.addEventListener('afterCartChanged', onSuccess);
    document.addEventListener('afterAddCartError', onError);
    button.dataset.checkoutTimer = String(window.setTimeout(() => {
      cleanup();
      reset(button);
    }, 20000));

    form.requestSubmit(submit);
  });
})();
